import { useTranslation } from 'react-i18next';

export default function AboutTrust() {
  const { t } = useTranslation();

  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="w-full px-6 md:px-10 flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
        {/* Left - Text */}
        <div className="w-full lg:w-[45%]">
          <span className="inline-block px-3 py-1 rounded-md bg-secondary-200 text-xs font-medium text-foreground-600 mb-6">
            {t('about.label', 'About Itaobuy Sheet')}
          </span>
          <h2 className="text-3xl md:text-[44px] font-bold text-foreground-950 leading-[1.15] tracking-tight">
            {t('about.title_line1', 'The Ultimate')}
            <br />
            {t('about.title_line2', 'Product Sourcing')}
            <br />
            {t('about.title_line3', 'Spreadsheet Tool')}
          </h2>
          <p className="mt-8 text-base text-foreground-600 leading-relaxed font-light max-w-md">
            {t('about.description')}
          </p>
        </div>

        {/* Right - Dark Green Card */}
        <div className="w-full lg:w-[50%]">
          <div className="rounded-[32px] bg-primary-500 p-10 md:p-12 relative overflow-hidden">
            {/* Decorative dots */}
            <div className="absolute top-8 right-8 flex gap-1.5">
              <span className="w-2 h-2 rounded-full bg-background-50/40"></span>
              <span className="w-2 h-2 rounded-full bg-background-50/30"></span>
              <span className="w-2 h-2 rounded-full bg-background-50/20"></span>
            </div>

            {/* Stat */}
            <p className="text-background-50/60 text-xs font-medium tracking-wide uppercase mb-8">
              {t('about.stat', 'Trusted by 10K+ Sellers')}
            </p>

            {/* Quote */}
            <blockquote className="text-background-50 text-lg md:text-xl leading-relaxed font-light">
              "{t('about.quote')}"
            </blockquote>

            {/* Author + CTA */}
            <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20east%20asian%20male%20entrepreneur%20with%20glasses%20on%20clean%20white%20studio%20background%20friendly%20confident%20smile%20modern%20business%20casual%20blazer%20sharp%20professional%20look&width=96&height=96&seq=about-avatar-v2&orientation=squarish"
                  alt={t('about.author')}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <p className="text-background-50 font-medium text-sm">{t('about.author')}</p>
                  <p className="text-background-50/50 text-xs">{t('about.role')}</p>
                </div>
              </div>

              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-[10px] bg-background-50/15 text-background-50 text-sm font-medium hover:bg-background-50/25 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {t('about.cta', 'itaobuy sheet →')}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}